// // ComingSoon.js
// import React, { useEffect, useState } from 'react';
// import './Coming.css';

// const Coming = () => {
//     const [countdown, setCountdown] = useState({
//         days: '00',
//         hours: '00',
//         minutes: '00',
//         seconds: '00'
//     });

//     useEffect(() => {
//         // Jumping "COMING SOON" text
//         function createJumpingText() {
//             const el = document.getElementById('comingsoon-jumping-text');
//             if (!el) return;

//             const text = "COMING SOON";
//             const rainbowColors = [
//                 '#ff6b6b', '#ffa726', '#ffee58', '#66bb6a',
//                 '#26c6da', '#42a5f5', '#7e57c2', '#ec407a',
//                 '#ff6b6b', '#ffa726', '#ffee58'
//             ];

//             el.innerHTML = '';

//             for (let i = 0; i < text.length; i++) {
//                 const span = document.createElement('span');
//                 span.textContent = text[i] === ' ' ? '\u00A0' : text[i];
//                 span.style.color = rainbowColors[i % rainbowColors.length];
//                 span.style.animation = `comingsoon-jump 2s infinite ease-in-out, comingsoon-colorChange 4s infinite linear`;
//                 span.style.animationDelay = `${i * 0.1}s, ${i * 0.3}s`;
//                 el.appendChild(span);
//             }
//         }

//         // Rockets
//         function createRockets() {
//             const container = document.getElementById('comingsoon-rocket-container');
//             if (!container) return;

//             for (let i = 0; i < 2; i++) {
//                 const rocket = document.createElement('div');
//                 rocket.className = 'comingsoon-rocket';
//                 rocket.style.animationDuration = `${15 + Math.random() * 20}s`;
//                 rocket.style.animationDelay  = `${Math.random() * 10}s`;

//                 rocket.innerHTML = `
//                     <div class="comingsoon-rocket-body">
//                         <div class="comingsoon-rocket-main"></div>
//                         <div class="comingsoon-rocket-window"></div>
//                         <div class="comingsoon-rocket-fin comingsoon-fin-left"></div>
//                         <div class="comingsoon-rocket-fin comingsoon-fin-right"></div>
//                         <div class="comingsoon-rocket-flame"></div>
//                     </div>
//                 `;

//                 rocket.addEventListener('click', function () {
//                     this.style.animationPlayState = this.style.animationPlayState === 'paused' ? 'running' : 'paused';
//                 });

//                 container.appendChild(rocket);
//             }
//         }

//         // Rising + shooting stars + twinkling background
//         function createRisingStars() {
//             const container = document.getElementById('comingsoon-stars-container');
//             if (!container) return;

//             const starColors = [
//                 '#ff6b6b','#ffa726','#ffee58','#66bb6a',
//                 '#26c6da','#42a5f5','#7e57c2','#ec407a',
//                 '#ffffff','#93c5fd','#60a5fa','#3b82f6'
//             ];

//             // Rising stars
//             for (let i = 0; i < 80; i++) {
//                 const star = document.createElement('div');
//                 star.className = 'comingsoon-rising-star';

//                 const left   = Math.random() * 100;
//                 const size   = Math.random() * 4 + 2;
//                 const color  = starColors[Math.floor(Math.random() * starColors.length)];
//                 const dur    = Math.random() * 15 + 10;
//                 const delay  = Math.random() * 20;

//                 star.style.left            = `${left}%`;
//                 star.style.width           = `${size}px`;
//                 star.style.height          = `${size}px`;
//                 star.style.background      = color;
//                 star.style.boxShadow       = `0 0 ${size*2}px ${color}`;
//                 star.style.animationDuration = `${dur}s`;
//                 star.style.animationDelay  = `${delay}s`;

//                 container.appendChild(star);
//             }

//             // Shooting stars
//             for (let i = 0; i < 15; i++) {
//                 const star = document.createElement('div');
//                 star.className = 'comingsoon-shooting-star';

//                 const left  = Math.random() * 100;
//                 const top   = Math.random() * 50;
//                 const color = starColors[Math.floor(Math.random() * starColors.length)];
//                 const dur   = Math.random() * 5 + 3;
//                 const delay = Math.random() * 15;

//                 star.style.left            = `${left}%`;
//                 star.style.top             = `${top}%`;
//                 star.style.background      = color;
//                 star.style.boxShadow       = `0 0 10px ${color}`;
//                 star.style.animationDuration = `${dur}s`;
//                 star.style.animationDelay  = `${delay}s`;

//                 container.appendChild(star);
//             }
//         }

//         function createBackgroundTwinkleStars() {
//             const container = document.getElementById('comingsoon-stars-container');
//             if (!container) return;

//             for (let i = 0; i < 100; i++) {
//                 const star = document.createElement('div');
//                 const size = Math.random() * 3 + 1;

//                 star.style.position     = 'absolute';
//                 star.style.width        = `${size}px`;
//                 star.style.height       = `${size}px`;
//                 star.style.background   = 'white';
//                 star.style.borderRadius = '50%';
//                 star.style.left         = `${Math.random() * 100}%`;
//                 star.style.top          = `${Math.random() * 100}%`;
//                 star.style.opacity      = Math.random() * 0.7 + 0.3;
//                 star.style.zIndex       = '1';
//                 star.style.animation    = `comingsoon-twinkle ${Math.random() * 5 + 3}s infinite alternate`;

//                 container.appendChild(star);
//             }
//         }

//         function createParticles() {
//             const container = document.getElementById('comingsoon-rocket-container');
//             if (!container) return;

//             for (let i = 0; i < 30; i++) {
//                 const p = document.createElement('div');
//                 p.className = 'comingsoon-particle';

//                 const size = Math.random() * 5 + 2;

//                 p.style.width  = `${size}px`;
//                 p.style.height = `${size}px`;
//                 p.style.left   = `${Math.random() * 100}%`;
//                 p.style.top    = `${Math.random() * 100}%`;

//                 const x1 = Math.random() * 100 - 50;
//                 const y1 = Math.random() * 100 - 50;
//                 const x2 = Math.random() * 100 - 50;
//                 const y2 = Math.random() * 100 - 50;
//                 const x3 = Math.random() * 100 - 50;
//                 const y3 = Math.random() * 100 - 50;

//                 p.style.setProperty('--x1', `${x1}px`);
//                 p.style.setProperty('--y1', `${y1}px`);
//                 p.style.setProperty('--x2', `${x2}px`);
//                 p.style.setProperty('--y2', `${y2}px`);
//                 p.style.setProperty('--x3', `${x3}px`);
//                 p.style.setProperty('--y3', `${y3}px`);

//                 p.style.animation = `comingsoon-float ${Math.random() * 10 + 10}s infinite linear`;

//                 container.appendChild(p);
//             }
//         }

//         function createSubscriptionBurst() {
//             const container = document.getElementById('comingsoon-stars-container');
//             if (!container) return;

//             const colors = ['#ff6b6b','#ffa726','#ffee58','#66bb6a','#26c6da','#42a5f5','#7e57c2','#ec407a'];

//             for (let i = 0; i < 30; i++) {
//                 const star = document.createElement('div');
//                 const size = Math.random() * 6 + 2;
//                 const color = colors[Math.floor(Math.random() * colors.length)];

//                 star.style.position   = 'absolute';
//                 star.style.width      = `${size}px`;
//                 star.style.height     = `${size}px`;
//                 star.style.background = color;
//                 star.style.borderRadius = '50%';
//                 star.style.left       = '50%';
//                 star.style.top        = '50%';
//                 star.style.opacity    = '0';
//                 star.style.zIndex     = '10';
//                 star.style.boxShadow  = '0 0 10px currentColor';

//                 container.appendChild(star);

//                 const angle = Math.random() * Math.PI * 2;
//                 const dist  = Math.random() * 300 + 100;
//                 const x = Math.cos(angle) * dist;
//                 const y = Math.sin(angle) * dist;

//                 star.animate([
//                     { transform: 'translate(0,0) scale(0)', opacity: 0 },
//                     { transform: 'translate(0,0) scale(1)', opacity: 1 },
//                     { transform: `translate(${x}px, ${y}px) scale(0)`, opacity: 0 }
//                 ], {
//                     duration: Math.random() * 1000 + 1000,
//                     easing: 'ease-out'
//                 });

//                 setTimeout(() => star.remove(), 2000);
//             }
//         }

//         // Init
//         createJumpingText();
//         createRockets();
//         createRisingStars();
//         createBackgroundTwinkleStars();
//         createParticles();

//         // Form
//         const form = document.getElementById('comingsoon-subscribe-form');
//         if (form) {
//             form.addEventListener('submit', function(e) {
//                 e.preventDefault();
//                 const input = this.querySelector('.comingsoon-email-input');
//                 const email = input.value.trim();

//                 if (email && email.includes('@') && email.includes('.')) {
//                     const notif = document.getElementById('comingsoon-notification');
//                     if (notif) {
//                         notif.style.display = 'flex';
//                         setTimeout(() => notif.style.display = 'none', 4000);
//                     }

//                     // Quick jump effect
//                     document.querySelectorAll('#comingsoon-jumping-text span').forEach(s => {
//                         s.style.animation = 'comingsoon-jump 0.5s ease-in-out';
//                         setTimeout(() => {
//                             s.style.animation = 'comingsoon-jump 2s infinite ease-in-out';
//                         }, 500);
//                     });

//                     createSubscriptionBurst();
//                     input.value = '';
//                     console.log(`Subscribed: ${email}`);
//                 } else {
//                     alert('Please enter a valid email address.');
//                 }
//             });
//         }

//         return () => {
//             if (form) form.removeEventListener('submit', () => {});
//         };
//     }, []);

//     // Countdown
//     useEffect(() => {
//         const update = () => {
//             const launch = new Date();
//             launch.setDate(launch.getDate() + 30);
//             launch.setHours(9, 0, 0, 0);

//             const diff = launch - Date.now();
//             if (diff < 0) {
//                 setCountdown({ days:'00', hours:'00', minutes:'00', seconds:'00' });
//                 return;
//             }

//             const d = Math.floor(diff / 86400000);
//             const h = Math.floor((diff % 86400000) / 3600000);
//             const m = Math.floor((diff % 3600000) / 60000);
//             const s = Math.floor((diff % 60000) / 1000);

//             setCountdown({
//                 days:    d.toString().padStart(2,'0'),
//                 hours:   h.toString().padStart(2,'0'),
//                 minutes: m.toString().padStart(2,'0'),
//                 seconds: s.toString().padStart(2,'0')
//             });
//         };

//         update();
//         const id = setInterval(update, 1000);
//         return () => clearInterval(id);
//     }, []);

//     return (
//         <div className="comingsoon-page">
//             <div className="comingsoon-notification" id="comingsoon-notification">
//                 <i className="fas fa-check-circle"></i>
//                 <span>You'll be notified when we launch!</span>
//             </div>

//             <div className="comingsoon-rocket-container" id="comingsoon-rocket-container"></div>
//             <div className="comingsoon-stars-container" id="comingsoon-stars-container"></div>

//             <div className="comingsoon-container">
//                 <h1 className="comingsoon-logo">
//                     <span className="comingsoon-logo-text">Krishna Finconcept Services</span>
//                 </h1>
//                 <p className="comingsoon-tagline">Financial Services</p>

//                 <div className="comingsoon-jumping-text" id="comingsoon-jumping-text"></div>

//                 <p className="comingsoon-message">
//                     We're launching a revolutionary financial platform that will transform how you manage loans,
//                     investments, and financial planning. Get ready for something amazing!
//                 </p>

//                 <div className="comingsoon-countdown">
//                     <div className="comingsoon-countdown-item">
//                         <span className="comingsoon-countdown-value">{countdown.days}</span>
//                         <span className="comingsoon-countdown-label">Days</span>
//                     </div>
//                     <div className="comingsoon-countdown-item">
//                         <span className="comingsoon-countdown-value">{countdown.hours}</span>
//                         <span className="comingsoon-countdown-label">Hours</span>
//                     </div>
//                     <div className="comingsoon-countdown-item">
//                         <span className="comingsoon-countdown-value">{countdown.minutes}</span>
//                         <span className="comingsoon-countdown-label">Minutes</span>
//                     </div>
//                     <div className="comingsoon-countdown-item">
//                         <span className="comingsoon-countdown-value">{countdown.seconds}</span>
//                         <span className="comingsoon-countdown-label">Seconds</span>
//                     </div>
//                 </div>

//                 <form className="comingsoon-subscribe-form" id="comingsoon-subscribe-form">
//                     <input
//                         type="email"
//                         className="comingsoon-email-input"
//                         placeholder="Enter email for early access"
//                         required
//                     />
//                     <button type="submit" className="comingsoon-subscribe-btn">
//                         <i className="fas fa-paper-plane"></i> Get Notified
//                     </button>
//                 </form>

//                 <div className="comingsoon-footer">
//                     <p>© {new Date().getFullYear()} Krishna Finconcept Services. All rights reserved.</p>
//                     <p>Transforming financial experiences with innovation</p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Coming;

import React, { useEffect, useState } from 'react';
import './Coming.css';
 
const Coming = () => {
    const [countdown, setCountdown] = useState({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
    });
 
    useEffect(() => {
        // Jumping "COMING SOON" text
        function createJumpingText() {
            const el = document.getElementById('comingsoon-jumping-text');
            if (!el) return;
 
            const text = "COMING SOON";
            const rainbowColors = [
                '#ff6b6b', '#ffa726', '#ffee58', '#66bb6a',
                '#26c6da', '#42a5f5', '#7e57c2', '#ec407a',
                '#ff6b6b', '#ffa726', '#ffee58'
            ];
 
            el.innerHTML = '';
 
            for (let i = 0; i < text.length; i++) {
                const span = document.createElement('span');
                span.textContent = text[i] === ' ' ? '\u00A0' : text[i];
                span.style.color = rainbowColors[i % rainbowColors.length];
                span.style.animation = `comingsoon-jump 2s infinite ease-in-out, comingsoon-colorChange 4s infinite linear`;
                span.style.animationDelay = `${i * 0.1}s, ${i * 0.3}s`;
                el.appendChild(span);
            }
        }
 
        // Rockets
        // Replace the ENTIRE createRockets() function with this:
function createRockets() {
    const container = document.getElementById('comingsoon-rocket-container');
    if (!container) return;

    // Clear existing rockets
    container.innerHTML = '';

    // Get the COMING SOON text position
    const jumpingText = document.getElementById('comingsoon-jumping-text');
    if (!jumpingText) return;

    const textRect = jumpingText.getBoundingClientRect();
    const textCenterX = textRect.left + textRect.width / 2;
    const textCenterY = textRect.top + textRect.height / 2;
    const orbitWidth = textRect.width * 0.8 + 100;
    const orbitHeight = textRect.height * 0.6 + 80;

    // Create 2 rockets with elliptical orbits around the text
    for (let i = 0; i < 2; i++) {
        const rocket = document.createElement('div');
        rocket.className = 'comingsoon-rocket';
        
        // Different animation durations for varied speeds
        const duration = 20 + i * 5; // 20s and 25s
        
        // Store orbit parameters as CSS variables
        rocket.style.setProperty('--orbit-center-x', `${textCenterX}px`);
        rocket.style.setProperty('--orbit-center-y', `${textCenterY}px`);
        rocket.style.setProperty('--orbit-width', `${orbitWidth}px`);
        rocket.style.setProperty('--orbit-height', `${orbitHeight}px`);
        
        rocket.style.animation = `comingsoon-orbit${i} ${duration}s infinite linear`;
        rocket.style.animationDelay = `${i * 2}s`;

        rocket.innerHTML = `
            <div class="comingsoon-rocket-body">
                <div class="comingsoon-rocket-main"></div>
                <div class="comingsoon-rocket-window"></div>
                <div class="comingsoon-rocket-fin comingsoon-fin-left"></div>
                <div class="comingsoon-rocket-fin comingsoon-fin-right"></div>
                <div class="comingsoon-rocket-flame"></div>
            </div>
        `;

        // Make rocket clickable to pause/resume
        rocket.addEventListener('click', function() {
            this.style.animationPlayState = 
                this.style.animationPlayState === 'paused' ? 'running' : 'paused';
        });

        container.appendChild(rocket);
    }

    // Add orbit animations to the CSS dynamically
    const style = document.createElement('style');
    style.id = 'comingsoon-rocket-orbits';
    
    // Create unique orbit animations for each rocket
    style.textContent = `
        @keyframes comingsoon-orbit0 {
            0% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50% - var(--orbit-width)/2), 
                              calc(var(--orbit-center-y) - 50%))
                    rotate(0deg);
            }
            25% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50%), 
                              calc(var(--orbit-center-y) - 50% - var(--orbit-height)/2))
                    rotate(90deg);
            }
            50% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50% + var(--orbit-width)/2), 
                              calc(var(--orbit-center-y) - 50%))
                    rotate(180deg);
            }
            75% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50%), 
                              calc(var(--orbit-center-y) - 50% + var(--orbit-height)/2))
                    rotate(270deg);
            }
            100% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50% - var(--orbit-width)/2), 
                              calc(var(--orbit-center-y) - 50%))
                    rotate(360deg);
            }
        }

        @keyframes comingsoon-orbit1 {
            0% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50% + var(--orbit-width)/2), 
                              calc(var(--orbit-center-y) - 50%))
                    rotate(180deg);
            }
            25% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50%), 
                              calc(var(--orbit-center-y) - 50% + var(--orbit-height)/2))
                    rotate(270deg);
            }
            50% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50% - var(--orbit-width)/2), 
                              calc(var(--orbit-center-y) - 50%))
                    rotate(360deg);
            }
            75% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50%), 
                              calc(var(--orbit-center-y) - 50% - var(--orbit-height)/2))
                    rotate(90deg);
            }
            100% {
                transform: 
                    translate(calc(var(--orbit-center-x) - 50% + var(--orbit-width)/2), 
                              calc(var(--orbit-center-y) - 50%))
                    rotate(180deg);
            }
        }
    `;
    
    // Remove existing orbit styles and add new ones
    const existingStyle = document.getElementById('comingsoon-rocket-orbits');
    if (existingStyle) existingStyle.remove();
    document.head.appendChild(style);
}
 
        // Rising + shooting stars + twinkling background
        function createRisingStars() {
            const container = document.getElementById('comingsoon-stars-container');
            if (!container) return;
 
            const starColors = [
                '#ff6b6b','#ffa726','#ffee58','#66bb6a',
                '#26c6da','#42a5f5','#7e57c2','#ec407a',
                '#ffffff','#93c5fd','#60a5fa','#3b82f6'
            ];
 
            // Rising stars
            for (let i = 0; i < 80; i++) {
                const star = document.createElement('div');
                star.className = 'comingsoon-rising-star';
 
                const left   = Math.random() * 100;
                const size   = Math.random() * 4 + 2;
                const color  = starColors[Math.floor(Math.random() * starColors.length)];
                const dur    = Math.random() * 15 + 10;
                const delay  = Math.random() * 20;
 
                star.style.left            = `${left}%`;
                star.style.width           = `${size}px`;
                star.style.height          = `${size}px`;
                star.style.background      = color;
                star.style.boxShadow       = `0 0 ${size*2}px ${color}`;
                star.style.animationDuration = `${dur}s`;
                star.style.animationDelay  = `${delay}s`;
 
                container.appendChild(star);
            }
 
            // Shooting stars
            for (let i = 0; i < 15; i++) {
                const star = document.createElement('div');
                star.className = 'comingsoon-shooting-star';
 
                const left  = Math.random() * 100;
                const top   = Math.random() * 50;
                const color = starColors[Math.floor(Math.random() * starColors.length)];
                const dur   = Math.random() * 5 + 3;
                const delay = Math.random() * 15;
 
                star.style.left            = `${left}%`;
                star.style.top             = `${top}%`;
                star.style.background      = color;
                star.style.boxShadow       = `0 0 10px ${color}`;
                star.style.animationDuration = `${dur}s`;
                star.style.animationDelay  = `${delay}s`;
 
                container.appendChild(star);
            }
        }
 
        function createBackgroundTwinkleStars() {
            const container = document.getElementById('comingsoon-stars-container');
            if (!container) return;
 
            for (let i = 0; i < 100; i++) {
                const star = document.createElement('div');
                const size = Math.random() * 3 + 1;
 
                star.style.position     = 'absolute';
                star.style.width        = `${size}px`;
                star.style.height       = `${size}px`;
                star.style.background   = 'white';
                star.style.borderRadius = '50%';
                star.style.left         = `${Math.random() * 100}%`;
                star.style.top          = `${Math.random() * 100}%`;
                star.style.opacity      = Math.random() * 0.7 + 0.3;
                star.style.zIndex       = '1';
                star.style.animation    = `comingsoon-twinkle ${Math.random() * 5 + 3}s infinite alternate`;
 
                container.appendChild(star);
            }
        }
 
        function createParticles() {
            const container = document.getElementById('comingsoon-rocket-container');
            if (!container) return;
 
            for (let i = 0; i < 30; i++) {
                const p = document.createElement('div');
                p.className = 'comingsoon-particle';
 
                const size = Math.random() * 5 + 2;
 
                p.style.width  = `${size}px`;
                p.style.height = `${size}px`;
                p.style.left   = `${Math.random() * 100}%`;
                p.style.top    = `${Math.random() * 100}%`;
 
                const x1 = Math.random() * 100 - 50;
                const y1 = Math.random() * 100 - 50;
                const x2 = Math.random() * 100 - 50;
                const y2 = Math.random() * 100 - 50;
                const x3 = Math.random() * 100 - 50;
                const y3 = Math.random() * 100 - 50;
 
                p.style.setProperty('--x1', `${x1}px`);
                p.style.setProperty('--y1', `${y1}px`);
                p.style.setProperty('--x2', `${x2}px`);
                p.style.setProperty('--y2', `${y2}px`);
                p.style.setProperty('--x3', `${x3}px`);
                p.style.setProperty('--y3', `${y3}px`);
 
                p.style.animation = `comingsoon-float ${Math.random() * 10 + 10}s infinite linear`;
 
                container.appendChild(p);
            }
        }
 
        function createSubscriptionBurst() {
            const container = document.getElementById('comingsoon-stars-container');
            if (!container) return;
 
            const colors = ['#ff6b6b','#ffa726','#ffee58','#66bb6a','#26c6da','#42a5f5','#7e57c2','#ec407a'];
 
            for (let i = 0; i < 30; i++) {
                const star = document.createElement('div');
                const size = Math.random() * 6 + 2;
                const color = colors[Math.floor(Math.random() * colors.length)];
 
                star.style.position   = 'absolute';
                star.style.width      = `${size}px`;
                star.style.height     = `${size}px`;
                star.style.background = color;
                star.style.borderRadius = '50%';
                star.style.left       = '50%';
                star.style.top        = '50%';
                star.style.opacity    = '0';
                star.style.zIndex     = '10';
                star.style.boxShadow  = '0 0 10px currentColor';
 
                container.appendChild(star);
 
                const angle = Math.random() * Math.PI * 2;
                const dist  = Math.random() * 300 + 100;
                const x = Math.cos(angle) * dist;
                const y = Math.sin(angle) * dist;
 
                star.animate([
                    { transform: 'translate(0,0) scale(0)', opacity: 0 },
                    { transform: 'translate(0,0) scale(1)', opacity: 1 },
                    { transform: `translate(${x}px, ${y}px) scale(0)`, opacity: 0 }
                ], {
                    duration: Math.random() * 1000 + 1000,
                    easing: 'ease-out'
                });
 
                setTimeout(() => star.remove(), 2000);
            }
        }
 
        // Init
        createJumpingText();
        createRockets();
        createRisingStars();
        createBackgroundTwinkleStars();
        createParticles();
 
        // Form
        const form = document.getElementById('comingsoon-subscribe-form');
        if (form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();
                const input = this.querySelector('.comingsoon-email-input');
                const email = input.value.trim();
 
                if (email && email.includes('@') && email.includes('.')) {
                    const notif = document.getElementById('comingsoon-notification');
                    if (notif) {
                        notif.style.display = 'flex';
                        setTimeout(() => notif.style.display = 'none', 4000);
                    }
 
                    // Quick jump effect
                    document.querySelectorAll('#comingsoon-jumping-text span').forEach(s => {
                        s.style.animation = 'comingsoon-jump 0.5s ease-in-out';
                        setTimeout(() => {
                            s.style.animation = 'comingsoon-jump 2s infinite ease-in-out';
                        }, 500);
                    });
 
                    createSubscriptionBurst();
                    input.value = '';
                    console.log(`Subscribed: ${email}`);
                } else {
                    alert('Please enter a valid email address.');
                }
            });
        }
 
        return () => {
            if (form) form.removeEventListener('submit', () => {});
        };
    }, []);
 
    // Countdown
    useEffect(() => {
        const update = () => {
            const launch = new Date();
            launch.setDate(launch.getDate() + 30);
            launch.setHours(9, 0, 0, 0);
 
            const diff = launch - Date.now();
            if (diff < 0) {
                setCountdown({ days:'00', hours:'00', minutes:'00', seconds:'00' });
                return;
            }
 
            const d = Math.floor(diff / 86400000);
            const h = Math.floor((diff % 86400000) / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);
 
            setCountdown({
                days:    d.toString().padStart(2,'0'),
                hours:   h.toString().padStart(2,'0'),
                minutes: m.toString().padStart(2,'0'),
                seconds: s.toString().padStart(2,'0')
            });
        };
 
        update();
        const id = setInterval(update, 1000);
        return () => clearInterval(id);
    }, []);
 
    return (
        <div className="comingsoon-page">
            <div className="comingsoon-notification" id="comingsoon-notification">
                <i className="fas fa-check-circle"></i>
                <span>You'll be notified when we launch!</span>
            </div>
 
            <div className="comingsoon-rocket-container" id="comingsoon-rocket-container"></div>
            <div className="comingsoon-stars-container" id="comingsoon-stars-container"></div>
 
            <div className="comingsoon-container">
                <h1 className="comingsoon-logo">
                    <span className="comingsoon-logo-text">Krishna Finconcept Services</span>
                </h1>
                <p className="comingsoon-tagline">Financial Services</p>
 
                <div className="comingsoon-jumping-text" id="comingsoon-jumping-text"></div>
 
                <p className="comingsoon-message">
                    We're launching a revolutionary financial platform that will transform how you manage loans,
                    investments, and financial planning. Get ready for something amazing!
                </p>
 
                <div className="comingsoon-countdown">
                    <div className="comingsoon-countdown-item">
                        <span className="comingsoon-countdown-value">{countdown.days}</span>
                        <span className="comingsoon-countdown-label">Days</span>
                    </div>
                    <div className="comingsoon-countdown-item">
                        <span className="comingsoon-countdown-value">{countdown.hours}</span>
                        <span className="comingsoon-countdown-label">Hours</span>
                    </div>
                    <div className="comingsoon-countdown-item">
                        <span className="comingsoon-countdown-value">{countdown.minutes}</span>
                        <span className="comingsoon-countdown-label">Minutes</span>
                    </div>
                    <div className="comingsoon-countdown-item">
                        <span className="comingsoon-countdown-value">{countdown.seconds}</span>
                        <span className="comingsoon-countdown-label">Seconds</span>
                    </div>
                </div>
 
                <form className="comingsoon-subscribe-form" id="comingsoon-subscribe-form">
                    <input
                        type="email"
                        className="comingsoon-email-input"
                        placeholder="Enter email for early access"
                        required
                    />
                    <button type="submit" className="comingsoon-subscribe-btn">
                        <i className="fas fa-paper-plane"></i> Get Notified
                    </button>
                </form>
 
                <div className="comingsoon-footer">
                    <p>© {new Date().getFullYear()} Krishna Finconcept Services. All rights reserved.</p>
                    <p>Transforming financial experiences with innovation</p>
                </div>
            </div>
        </div>
    );
};
 
export default Coming;
 